export default {
    multiple_myeloma_treatment_10001: 'Any treatment',
    multiple_myeloma_treatment_10002: 'Treated with an isatuximab-containing regimen',
    multiple_myeloma_treatment_10003: 'Treated with a daratumumab-containing regimen',
    multiple_myeloma_treatment_10004:
        'Treated with a regimen not containing isatuximab or daratumumab',
};
